import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData } from '@pages/reporting-pages/deliveries-customer/store/selectors';
import { CustomerParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/deliveries-customer/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetDeliveriesCustomerMutation } from '@api/order-reporting/deliveryApi';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/deliveries-customer/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/deliveries-customer/grid/Grid';
import { headersObject } from '@pages/reporting-pages/deliveries-customer/headersObject';



const DeliveriesCustomer = () => {

	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: CustomerParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ runReset ] = useResetDeliveriesCustomerMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');

			if (!paramDateFrom || !paramDateTo) return;

			let newSearchParams: CustomerParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		runReset();
	},[]);

	return (
		<AppPage
			className='reporting-page deliveries-customer'
			pageLabel='Report dodávek - Customer'
			resetPageApi={resetAllApi}
			csvData={{
				headers: headersObject,
				data: gridData,
				filename: 'reporting-dodavky-customer'
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default DeliveriesCustomer;